import CreateEventForm from "../forms/CreateEventForm.jsx";
import Modal from "../modals/Modal.jsx";
import Button from "../ui/Button.jsx";

function AddEventModal() {
    return (
        <div className="admin-compact-panel">
            <div className="admin-panel-intro">
                <div>
                    <h2>Add an event manually</h2>
                    <p>Create one event using the standard event form.</p>
                </div>
                <Modal>
                    <Modal.Open opens="event-form">
                        <Button size="small">Add event</Button>
                    </Modal.Open>
                    <Modal.Window name="event-form" label="Add an event">
                        <CreateEventForm />
                    </Modal.Window>
                </Modal>
            </div>
        </div>
    );
}

export default AddEventModal;
